import * as React from "react";
import InputOptions from "./InputOptions";
import PickerContainer, {
  type PickerContainerClassNames,
} from "./PickerContainer";

export type DropdownOption<T extends string> = {
  value: T;
  label: string;
};

export type DropdownProps<T extends string> = {
  label?: string;
  value: T;
  options: ReadonlyArray<DropdownOption<T>>;
  onChange: (value: T) => void;
  className?: string;
  classNames?: PickerContainerClassNames & { container?: string };
  placeholder?: string;
};

export default function Dropdown<T extends string>({
  label,
  value,
  options,
  onChange,
  className,
  classNames,
  placeholder,
}: DropdownProps<T>) {
  const selectedLabel =
    options.find((o) => o.value === value)?.label ?? String(value);

  return (
    <InputOptions
      className={className}
      value={String(value)}
      onChange={(v) => onChange(v as T)}
      options={options.map((o) => ({ value: String(o.value), label: o.label }))}
    >
      <PickerContainer
        label={label}
        value={selectedLabel}
        className={classNames?.container}
        placeholder={placeholder}
        classNames={classNames}
      />
    </InputOptions>
  );
}
